import { useState } from 'react';
import { Icon } from '@/components/foundations';
import { Button, KeyRow } from '@/components/forms';

export type PluggyItemFormProps = {
  /** Valor inicial do ID do item. */
  value?: string;
  onSubmit?: (itemId: string) => void;
  loading?: boolean;
  id?: string;
};

/** ID do item Pluggy + Conectar + aviso de que a senha do banco nunca passa pelo Lisboon. */
export function PluggyItemForm({ value = '', onSubmit, loading = false, id = 'item' }: PluggyItemFormProps) {
  const [itemId, setItemId] = useState(value);
  return (
    <>
      <label className="label" htmlFor={id} style={{ fontWeight: 500, fontSize: 16 }}>ID do item Pluggy</label>
      <KeyRow field={{ id, value, editable: true, onChange: setItemId }}>
        <Button className="btn-reveal" style={{ padding: '0 22px' }} loading={loading} onClick={() => onSubmit?.(itemId.trim())}>
          {loading ? 'Conectando…' : 'Conectar'}
        </Button>
      </KeyRow>
      <p className="warn-line"><Icon name="lock" />O Lisboon nunca vê sua senha do banco.</p>
    </>
  );
}
